export const blacklist =['0x1045D6f3768F4DE728f30e3Ea110C4Cb706B7384','0x7BCdd7784Aa73C6697CA1Bb122F9540e4F5D7210']